import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "general__download",
  "use": "general__download-usage",
  "viewBox": "0 0 23 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 23 18\" id=\"general__download\">\n    <path fill=\"none\" stroke-linecap=\"round\" stroke-width=\"1.5\" d=\"m1.28 10.1.06 6.37M21.6 10.1l-.05 6.37m-19.95 0h19.68M6.39 9.03l5.32 4.25m5.31-4.25-5.31 4.25M11.7 1.6v11.68\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol